import { Signal } from "./Signal.js";
import { Slot } from "./Slot.js";

export class SlotThrottle<T extends any[]> extends Slot<T> {
    public wait: number = 0;

    private _timeout: any = null;
    private _isThrottling: boolean = false;
    private _args: any[] = null;

    public execute(target: Signal<T>, args: any[]): void {
        if (this.wait <= 0) {
            if (this.enabled) {
                this.listener.apply(this.context, args as any);
            }
            return;
        }

        if (this._isThrottling) {
            this._args = args;
            return;
        }

        this._args = args;
        this.immediate();
    }

    public get isThrottling(): boolean {
        return this._isThrottling;
    }

    public immediate(): void {
        clearTimeout(this._timeout);
        this._timeout = null;
        if (this._args) {
            if (this.enabled) {
                this.listener.apply(this.context, this._args as any);
            }
            this._args = null;
            this._isThrottling = true;
            this._timeout = setTimeout(() => {
                this._isThrottling = false;
                if (this._args) {
                    this.immediate();
                }
            }, this.wait);
        } else {
            this._isThrottling = false;
        }
    }

    public cancel(): void {
        clearTimeout(this._timeout);
        this._timeout = null;
        this._args = null;
        this._isThrottling = false;
    }

    public dispose(): void {
        this.cancel();
        this._timeout = null;
        super.dispose();
    }
}